import { useEffect, useMemo } from 'react';

import { IAnyModelType, SnapshotIn } from 'mobx-state-tree';

export interface UseModelOptions {
	disableFetch?: boolean;
}

export default function useModel<T extends IAnyModelType>(
	Model: T,
	initial: SnapshotIn<T> = {} as SnapshotIn<T>,
	deps: any[] = [],
	options: UseModelOptions = {},
) {
	const { disableFetch = false } = options;

	const model = useMemo(() => Model.create(initial), [Model, ...deps]);

	useEffect(() => {
		if (!disableFetch && deps.length) {
			model.fetch();
		}
	}, [model, disableFetch, ...deps]);

	return model;
}
